import { createAuthService } from '@/modules/auth/services/auth.service';

import { createSupabaseAuthClient } from './auth-client/supabase-auth.client';

/**
 * Composition root — o único lugar do app onde as dependências são ligadas.
 *
 * É também o **único** arquivo de `services/` autorizado a importar de
 * `modules/`, e a exceção está declarada no `eslint.config.js` (bloco 3.2). Ela
 * existe porque um composition root, por definição, conhece tudo o que compõe.
 *
 * ## Estado atual: Supabase em todos os ambientes
 *
 * O stub em memória sobre `localStorage` foi removido junto com esta troca. Ele
 * existia porque o schema não tinha migrations e as telas de auth não teriam como
 * ser exercitadas; hoje as tabelas existem
 * (`supabase/migrations/*_create_auth_base.sql`) e manter dois caminhos só criaria
 * a classe de bug em que o cadastro funciona em desenvolvimento e falha no ar
 * porque a RLS nunca foi exercitada.
 *
 * A consequência prática é que **desenvolvimento agora precisa de rede e de um
 * `.env` preenchido**. Sem `VITE_SUPABASE_URL` e `VITE_SUPABASE_PUBLISHABLE_KEY`,
 * `services/supabase/client.ts` lança no boot, de propósito: falhar alto na
 * primeira tela é melhor do que um login que erra sem explicar por quê.
 */
const { auth, accounts } = createSupabaseAuthClient();

export const authService = createAuthService({ auth, accounts });
